module.exports = __webpack_public_path__ + "img/41_17.45e6d349.png";